import CovidTypeform from 'landing/covid/CovidTypeform';
import CovidVaccine from 'landing/covid/CovidVaccine';
import DefaultLayout from '../components/layout/layout/DefaultLayout';

const Covid = () => {
  return (
    <DefaultLayout>
      <CovidVaccine />
      <CovidTypeform />
    </DefaultLayout>
  );
};

export default Covid;
